import { hubSpotMethods } from './hubSpotMethods';

export const HubSpotUserUpdateEvents = {
  identifyUser: (email: string) => {
    hubSpotMethods.update(email);
  },
};
